/** @module AQL/NewInspectionWizard */
define([
	"dojo/_base/declare",
	"designSystem/types/button-types",
	"csi/locale",
	"csi/wizard/Widget",
	"csi/xml"
], function(declare, {ButtonEnum}, locale, Widget, xml) {

	const {
		BUTTON_FINISH_GO
	} = ButtonEnum;

	return declare(Widget, {
		/**
		 * @override
		 * Since new final inspection wizard has 3 pages and only 2 steps with the title details infomation, pop up the empty entry for the page 3
		 * */
		_createStepItems: function(list) {
			if (this.defView.m_id === "NewFinalInspection") {
				list.pop();
			}

			this.inherited(arguments);
		},
		
		/**
		 * @override
		 * C8-26043:  Remove the save and go button.
		 */
		canShowButton: function(idAction) {
			return (idAction === BUTTON_FINISH_GO) ? false : this.inherited(arguments);
		},

		/**
		 * @override
		 * Customize names for shipments as to only include Shipment Orders with SKU (removing Shipment Term)
		 */
		onPopulatePreviousSubtitle: function(names) {
			const {
				cacheView,
				params,
			} = this;
			const { defView } = params;

			const orderWizard = defView.m_id === "NewFinalInspectionsFromPOLinesWizard";
			const shipmentWizard = defView.m_id === "NewFinalInspectionsFromShipmentsWizard";
			if (orderWizard) {
				const fd = defView.getFormData();
				const selectedNodes = fd.getSelectedNodes();
				const shipmentParentNodes = selectedNodes.map(node => cacheView.getNode(node.__Parent__));
				names = selectedNodes.map((node, index) => {
					return `${locale.getNodeConfiguredName(shipmentParentNodes[index])} (${locale.getNodeConfiguredName(selectedNodes[index])})`;
				});
			} else if (shipmentWizard) {
				const { m_fields } = defView.getFormData();
				// show all valid fields
				names = m_fields.map(field => field.getFocusNode().value).filter(value => value);
			}
			return names;
		},

		/**
		 * @override
		 * Since this wizard has 3 pages and only 2 steps with the title details infomation, force the step pane show up
		 * */
		canShowStepPane: function() {
			return true;
		},

		/**
		 * @override
		 * Get the correct stepCard
		 * */
		_getStepCardByPage: function(page) {
			const pageIndex = this.getIndexOfPage(page);
			
			if (pageIndex == 2) {
				// we don't have the entry for the page 3, share with the step 2
				return this._getStepCardByIndex(1);
			}
			
			return this._getStepCardByIndex(pageIndex);
		}
	});
});